module.exports = __webpack_public_path__ + "static/img/logo_47.8b4b2f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_47.png
// module id = /5Y9
// module chunks = 1